import { Descriptions, Flex, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { BudgetCategoryAttributeDescriptionsStyled } from './styles/BudgetCategoryAttributeDescriptionsStyled'

interface IAttributeDescription {
  label: string
  value: string[]
}

export interface IBudgetCategoryAttributeDescriptionsProps {
  attributes: IAttributeDescription[]
  isSourceOfTruth?: boolean
}

const renderAttributeAsText = (attributes: string[]) => {
  if (!attributes || !attributes.length) return <Text inline>--</Text>
  return attributes.map((attribute, index) => (
    <span key={`${attribute}-${index}`} className='attribute-wrapper'>
      <Text inline>{attribute}</Text>
      {index === attributes.length - 1 || ', '}
    </span>
  ))
}

export const BudgetCategoryAttributeDescriptions = ({
  attributes,
  isSourceOfTruth,
}: IBudgetCategoryAttributeDescriptionsProps) => {
  const intl = useProcurifyIntl()

  return (
    <BudgetCategoryAttributeDescriptionsStyled>
      <Descriptions>
        {attributes.map(({ label, value }) => (
          <Descriptions.Item label={label} key={`${label}-attribute`}>
            <Flex.Row spacing={0}>{renderAttributeAsText(value)}</Flex.Row>
          </Descriptions.Item>
        ))}
        {isSourceOfTruth !== undefined && (
          <Descriptions.Item
            label={intl.formatMessage(messages.sourceOfTruthLabel)}
          >
            {intl.formatMessage(
              isSourceOfTruth ? messages.yesText : messages.noText
            )}
          </Descriptions.Item>
        )}
      </Descriptions>
    </BudgetCategoryAttributeDescriptionsStyled>
  )
}

BudgetCategoryAttributeDescriptions.displayName =
  'BudgetCategoryAttributeDescriptions'
